<template>
  <gg-card>
    <gg-card-header>
      Adjust Spam Threshold Score
    </gg-card-header>
    <gg-card-text>
      <v-row v-if="$attrs.pending">
        <v-col cols="12" class="text-center py-10">
          <v-progress-circular indeterminate color="primary" size="70" />
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col cols="12">
          Current score is <b>{{ scoreText }}</b>
        </v-col>
        <v-col cols="12" md="6">
          <gg-select v-model="scoreSelect"
                     :items="score_items"
                     item-text="label"
                     item-value="value"
                     name="scoreSelect"
          />
        </v-col>
        <v-col v-if="isCustomScore" cols="12" md="6">
          <gg-text-field v-model="scoreValue"
                         name="Score"
                         data-vv-as="Spam Threshold Score"
                         v-validate="'required|min_value:1|max_value:50'"
                         :error-messages="errors.collect('Score')"
          />
        </v-col>
        <v-col cols="12" class="pt-0">
          <gg-btn primary :loading="pending" @click="updateScore">Save</gg-btn>
        </v-col>
      </v-row>
    </gg-card-text>
  </gg-card>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'SpamThresholdScore',
  data: () => ({
    pending: false,
    score_items: [
      {
        value: '1',
        label: 'Aggressive, Many False Positives (1)'
      },
      {
        value: '4',
        label: 'Recommended for Well-Tested Servers (4)'
      },
      {
        value: '5',
        label: 'Default (5)'
      },
      {
        value: '8',
        label: 'Recommended For Internet service providers (8)'
      },
      {
        value: '10',
        label: 'Passive, Only Very Obvious Spam (10)'
      },
      {
        value: '',
        label: 'Custom'
      }
    ],
    scoreModel: '',
    scoreValue: ''
  }),
  computed: {
    ...mapGetters({
      spam_score: 'spam_filters/spam_score',
    }),
    checkInitialCustomScore () {
      // check if score is from preset
      return this.score_items.find(item => item.value === this.spam_score)
    },
    scoreText () {
      return !this.checkInitialCustomScore ? `Custom (${this.spam_score})` : this.checkInitialCustomScore?.label
    },
    isCustomScore () {
      return this.scoreModel === ''
    },
    scoreSelect: {
      get () {
        return this.scoreModel
      },
      set (val) {
        const presetScore = this.score_items.find(item => item.value === val)
        this.scoreModel = !presetScore ? '' : val
        if (val !== '') {
          this.scoreValue = val
        }
      }
    }
  },
  methods: {
    ...mapActions({
      updateUserPreferences: 'spam_filters/updateUserPreferences',
      reportSuccess: 'reportSuccess',
      reportError: 'reportError'
    }),
    ...mapMutations({
      setSpamScore: 'spam_filters/SET_SPAM_SCORE'
    }),
    async updateScore () {
      const valid = await this.$validator.validateAll()
      if (!valid) {
        return
      }

      try {
        this.pending = true
        await this.updateUserPreferences({ score: this.scoreValue, _username: this.$route.query.user })
        this.setSpamScore(this.scoreValue)
        const msg = `Threshold score successfully updated. Current value is ${this.scoreValue}`

        this.reportSuccess(msg)
      } catch (e) {
        this.reportError(e)
      } finally {
        this.pending = false
      }
    }
  },
  watch: {
    spam_score (val) {
      this.scoreSelect = val
    }
  }
}
</script>
